import EventBus from '@/scripts/event-bus';
import { api } from '@/scripts/api';
import { helpers } from '@/scripts/helpers';
import { OpportunityHelpers } from '@/components/sliding-widgets/opportunity-details-widget/opportunity-helpers';

export const registeredDealsTab = {
    state: () => ({
        refreshingRegisteredDeals: false,
        refreshRegisteredDealsController: new AbortController()
    }),

    getters: {
        registeredDeals(state, getters, rootState) {
            return rootState.opportunity.registeredDeals;
        }
    },

    actions: {
        refreshRegisteredDeals({ state, rootState }) {
            const opportunityId = rootState.opportunity.id;
            const expand = '$expand=RegisteredDeals($expand=Agency($select=Id,Name))';
            const select = '$select=RegisteredDeals';

            state.refreshingRegisteredDeals = true;

            return api
                .get(`/service/Deals?$filter=Id eq ${opportunityId}&${expand}&${select}`)
                .then((response) => {
                    const opportunityResponse = response.data.value[0];
                    rootState.opportunity.registeredDeals = OpportunityHelpers.getRegisteredDeals(opportunityResponse);
                })
                .finally(() => {
                    state.refreshingRegisteredDeals = false;
                });
        },

        deleteRegisteredDeal({ state }, registeredDeal) {
            state.refreshRegisteredDealsController.abort();
            state.refreshRegisteredDealsController = new AbortController();

            api
                .delete(`/api/RegisteredDeals/${registeredDeal.id}`, null, state.refreshRegisteredDealsController.signal)
                .then(() => {
                    helpers.showSuccessNotification(
                        'Your deal has been successfully deleted.'
                    );
                    EventBus.$emit('registered-deal:update');
                    EventBus.$emit('opportunity:update');
                })
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        helpers.showFailNotification(
                            'Your deal could not be deleted. Please contact support.',
                            { error }
                        );
                    }
                });
        }
    }
};